import LatoTTF from './Lato.ttf';
import LatoSVG from './Lato.svg';
import LatoEOT from './Lato.eot';
import LatoWOFF from './Lato.woff';
import LatoWOFF2 from './Lato.woff2';

import LatoLatin300WOFF from './lato-latin-300-normal.woff';
import LatoLatin300WOFF2 from './lato-latin-300-normal.woff2';
import LatoLatin300EXTWOFF from './lato-latin-ext-300-normal.woff';
import LatoLatin300EXTWOFF2 from './lato-latin-ext-300-normal.woff2';

import AntonTTF from './Anton.ttf';
import AntonSVG from './Anton.svg';
import AntonEOT from './Anton.eot';
import AntonWOFF from './Anton.woff';
import AntonWOFF2 from './Anton.woff2';
import OpenSansTTF from './OpenSans.ttf';
import OpenSansSVG from './OpenSans.svg';
import OpenSansEOT from './OpenSans.eot';
import OpenSansWOFF from './OpenSans.woff';
import OpenSansWOFF2 from './OpenSans.woff2';
import PaytoneOneTTF from './PaytoneOne.ttf';
import PaytoneOneSVG from './PaytoneOne.svg';
import PaytoneOneEOT from './PaytoneOne.eot';
import PaytoneOneWOFF from './PaytoneOne.woff';
import PaytoneOneWOFF2 from './PaytoneOne.woff2';
import MetropolisEOT from './Metropolis-Regular.eot';
import MetropolisTTF from './Metropolis-Regular.ttf';
import MetropolisWOFF from './Metropolis-Regular.woff';
import MetropolisWOFF2 from './Metropolis-Regular.woff2';
import MetropolisSVG from './Metropolis-Regular.svg';

export default {
  Lato: {
    ttf: LatoTTF,
    svg: LatoSVG,
    eot: LatoEOT,
    woff: LatoWOFF,
    woff2: LatoWOFF2,
    300: {
      woff: LatoLatin300WOFF,
      woff2: LatoLatin300WOFF2,
      woffExt: LatoLatin300EXTWOFF,
      woff2EXt: LatoLatin300EXTWOFF2
    }
  },
  Anton: {
    ttf: AntonTTF,
    svg: AntonSVG,
    eot: AntonEOT,
    woff: AntonWOFF,
    woff2: AntonWOFF2
  },
  OpenSans: {
    ttf: OpenSansTTF,
    svg: OpenSansSVG,
    eot: OpenSansEOT,
    woff: OpenSansWOFF,
    woff2: OpenSansWOFF2
  },
  PaytoneOne: {
    ttf: PaytoneOneTTF,
    svg: PaytoneOneSVG,
    eot: PaytoneOneEOT,
    woff: PaytoneOneWOFF,
    woff2: PaytoneOneWOFF2
  },
  Metropolis: {
    ttf: MetropolisTTF,
    svg: MetropolisSVG,
    eot: MetropolisEOT,
    woff: MetropolisWOFF,
    woff2: MetropolisWOFF2
  }
};
